import { getCashMovementDetail } from '@repo/accounts-services'
import { defineSagaForService } from '@repo/core'
import { cashMovementDetailDataActions } from '../../../../slices'

export const serviceConfig = defineSagaForService({
  [cashMovementDetailDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getCashMovementDetail,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: cashMovementDetailDataActions.getResponse.type,
    actionTypeRequest: cashMovementDetailDataActions.getRequest.type,
  },
})
